// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";

function make(callback, milliseconds) {
  var lastCall = {
    contents: undefined
  };
  var pending = {
    contents: undefined
  };
  var cancelPending = function () {
    var id = pending.contents;
    if (id !== undefined) {
      clearTimeout(Caml_option.valFromOption(id));
      return ;
    }
    
  };
  var throttled = function (first, second) {
    var now = Date.now();
    var last = lastCall.contents;
    if (last !== undefined && now - last < milliseconds) {
      cancelPending();
      pending.contents = Caml_option.some(setTimeout((function () {
                  pending.contents = undefined;
                  lastCall.contents = now;
                  callback(first, second);
                }), milliseconds - (now - last | 0) | 0));
      return ;
    }
    lastCall.contents = now;
    callback(first, second);
  };
  return [
          throttled,
          cancelPending
        ];
}

export {
  make ,
}
/* No side effect */
